var storefrontApp = angular.module('storefrontApp');
storefrontApp.controller('pastContestWinnerController', ['$scope', 'contestService', '$sce', 'loaderService', '$location', 'modalService', 'urlService', "$document", "$window",
    function ($scope, contestService, $sce, loaderService, location, modalService, urlService, $document, $window) {

        $scope.pg = '1';
        $scope.pages = 1;
        $scope.ipp = '30';
        $scope.ippOptions = ['30', '60', '90'];

        $scope.selectedEntryIndex = 0;

        $scope.initialize = function () {
            GetContestsBySite();
            GetContestAppSettings();
        }

        function GetContestAppSettings() {
            contestService.getContestAppsettings().then(function (data) {
                $scope.contestAppsettings = data.data;
            })
        }

        function GetContestsBySite() {
            contestService.getContestsBySite().then(function (data) {
                $scope.contests = data.data;

                if ($scope.contests != null && $scope.contests.length > 0) {
                    var urlString = window.location.href;
                    var url = new URL(urlString);
                    var param = url.searchParams.get("contestId");
                    
                    if (param == null) {
                        $scope.selectedContest = $scope.contests[0];
                        $scope.selectedContestId = $scope.selectedContest.contestId.toString();
                    } else {
                        $scope.selectedContest = $scope.contests.filter(function (x) { return x.contestId == param })[0];
                        $scope.selectedContestId = $scope.selectedContest.contestId.toString();
                    }

                    $scope.getContestEntries();
                }
            })
        }

        $scope.getContestEntries = function () {
            contestService.getContestEntries($scope.selectedContestId).then(function (response) {
                $scope.selectedContest = $scope.contests.filter(function (x) { return x.contestId == $scope.selectedContestId; })[0];

                $scope.totalEntries = response.data.length;

                $scope.contestWinners = response.data.filter(function (x) {
                    return x.winnerPosition == 1 || x.winnerPosition == 2 || x.winnerPosition == 3;
                });

                $scope.contestWinners.sort(function (a, b) { return a.winnerPosition - b.winnerPosition });

                var honors = response.data.filter(function (x) {
                    return x.winnerPosition == 4;
                });

                var entries = response.data.filter(function (x) {
                    return x.winnerPosition == 0;
                });

                $scope.contestEntries = honors.concat(entries);

                $scope.pages = $scope.contestEntries.length % $scope.ipp > 0 ? Math.floor($scope.contestEntries.length / $scope.ipp) + 1 : $scope.contestEntries.length / $scope.ipp;

                setTimeout(function () { $scope.onIppChange() }, 200);
            })
        }

        $scope.openEntryDetailModal = function (index) {
            var entry = $scope.filterEntries[index];

            $scope.selectedEntryIndex = index;

            if (entry != null && entry.designsUsedInProject != null) {
                var prodIds = entry.designsUsedInProject.split(',');

                if (entry.designsUsedInProject.includes("(")) {
                    for (var i = 0; i < prodIds.length; i++) {
                        prodIds[i] = prodIds[i].substring(0, prodIds[i].indexOf("("));
                    }
                }

                loaderService.show();

                contestService.getProductInfo(prodIds).then(function (data) {
                    $scope.selectedEntry = entry;
                    $scope.designsUsed = data.data;
                    modalService.open("entryDetails");

                    loaderService.hide();
                })
            }
        }

        $scope.closeEntryDetailModal = function () {
            modalService.close("entryDetails");
        }

        $scope.getProductImage = function (item) {
            var defName = item.properties.filter(function (x) { return x.displayName.toLowerCase() == "definitionname" });
            var def = "StockDesign";

            if (defName != null && defName.length > 0) {
                def = defName[0].value;
            }

            item.definitionName = def;

            return urlService.getImageUrl(item);
        }

        $scope.getProductUrl = function (item) {
            var defName = item.properties.filter(function (x) { return x.displayName.toLowerCase() == "definitionname" });
            var def = "StockDesign";

            if (defName != null && defName.length > 0) {
                def = defName[0].value;
            }

            item.definitionName = def;

            return urlService.getProductUrl(item);
        }

        $scope.initialize();


        $scope.loadPagination = function () {
            if (document.getElementById('pagination') != null) {
                pagination.Init(document.getElementById('pagination'), {
                    size: $scope.pages,
                    page: Number($scope.pg),
                    step: 2
                });
            }
        }

        $scope.onIppChange = function () {
            var ippDoc = document.getElementById("ipp");

            $scope.pg = 1;

            if (ippDoc != null) {
                $scope.ipp = ippDoc.value;
            }

            $scope.pages = $scope.contestEntries.length % $scope.ipp > 0 ? Math.floor($scope.contestEntries.length / $scope.ipp) + 1 : $scope.contestEntries.length / $scope.ipp;

            $scope.loadPagination();
            $scope.onFilterChange();
        }

        $scope.onFilterChange = function () {
            $scope.pg = '1';
            $scope.getEntryData();
        }

        $scope.getEntryData = function () {
            var start = (+$scope.pg - 1) * +$scope.ipp;
            var end = (+$scope.pg) * +$scope.ipp;

            $scope.filterEntries = $scope.contestEntries.slice(start, end);
        }

        $scope.changePage = function (requestedPage) {
            if (requestedPage != "prev" && requestedPage != "next") {
                pagination.page = Number(requestedPage);
                $scope.pg = requestedPage != null ? requestedPage.toString() : "1";
            } else if (requestedPage == "prev") {
                pagination.page = Number($scope.pg) - 1;
                $scope.pg = (Number($scope.pg) - 1).toString();
            } else if (requestedPage == "next") {
                pagination.page = Number($scope.pg) + 1;
                $scope.pg = (Number($scope.pg) + 1).toString();
            }

            $window.scrollTo(0, 250);

            pagination.Start();
            $scope.getEntryData();
        };

        var pagination = {
            code: "",
            Extend: function (data) {
                data = data || {};
                pagination.size = data.size || 1;
                pagination.page = data.page || 1;
                pagination.step = data.step || 2;
            },
            Add: function (first, last) {
                for (var i = first; i < last; i++) {
                    pagination.code += "<a class='flex center'>" + i + "</a>";
                }
            },
            Last: function () {
                pagination.code +=
                    '<i class="flex center">...</i><a class="flex center">' + pagination.size + "</a>";
            },
            First: function () {
                pagination.code +=
                    '<a class="flex center">1</a><i class="flex center">...</i>';
            },
            Click: function () {
                var requestedPage = +this.innerHTML;
                $scope.changePage(requestedPage);
                $scope.$apply();
                pagination.Start();
            },
            Prev: function () {
                pagination.page--;
                if (pagination.page < 1) {
                    pagination.page = 1;
                }
                $scope.changePage(pagination.page);
                $scope.$apply();
                pagination.Start();
            },
            Next: function () {
                pagination.page++;
                if (pagination.page > pagination.size) {
                    pagination.page = pagination.size;
                }
                $scope.changePage(pagination.page);
                $scope.$apply();
                pagination.Start();
            },
            Bind: function () {
                var prev = $document[0].getElementById("prev");
                var next = $document[0].getElementById("next");
                if ($scope.pg == '1') {
                    prev.classList.add('disabled');
                }
                else {
                    prev.classList.remove('disabled');
                }
                if ($scope.pg == $scope.pages) {
                    next.classList.add('disabled');
                }
                else {
                    next.classList.remove('disabled');
                }

                var a = pagination.e.getElementsByTagName("a");
                for (var i = 0; i < a.length; i++) {
                    if (+a[i].innerHTML === pagination.page) {
                        a[i].classList.add("active");
                    }
                    a[i].addEventListener("click", pagination.Click, false);
                }
            },
            Finish: function () {
                pagination.e.innerHTML = pagination.code;
                pagination.code = "";
                pagination.Bind();
            },
            Start: function () {
                if (pagination.size < pagination.step * 2 + 6) {
                    pagination.Add(1, pagination.size + 1);
                } else if (pagination.page < pagination.step * 2 + 1) {
                    pagination.Add(1, pagination.step * 2 + 4);
                    pagination.Last();
                } else if (
                    pagination.page >
                    pagination.size - pagination.step * 2
                ) {
                    pagination.First();
                    pagination.Add(
                        pagination.size - pagination.step * 2 - 2,
                        pagination.size + 1
                    );
                } else {
                    pagination.First();
                    pagination.Add(
                        pagination.page - pagination.step,
                        pagination.page + pagination.step + 1
                    );
                    pagination.Last();
                }
                pagination.Finish();
            },
            Buttons: function (e) {
                var nav = e.getElementsByTagName("a");
                nav[0].addEventListener("click", pagination.Prev, false);
                nav[1].addEventListener("click", pagination.Next, false);
            },
            Create: function (e) {
                if (angular.isDefined(e)) {
                    var html = [
                        '<div id="prev" class="prev"><a class="flex center"><i class="fa fa-angle-left"></i></a></div>',
                        '<span class="flex row"></span>',
                        '<div id="next" class="next"><a class="flex center"><i class="fa fa-angle-right"></i></a></div>',
                    ];
                    e.innerHTML = html.join("");
                    pagination.e = e.getElementsByTagName("span")[0];
                    pagination.Buttons(e);
                }
            },
            Init: function (e, data) {
                pagination.Extend(data);
                pagination.Create(e);
                pagination.Start();
            }
        };

    }])
